/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';

import { useInfoModal } from '../info-modal/Hooks';

import { ScopeMetadata } from '@utils/pageConfig/Types';
import { capitalizeFirstLetter } from '@utils/StringUtils';
import { Periodicity } from '../time-period-selector/PeriodsTypes';

export type PanelTypeProps = {
  scopeMetadata?: ScopeMetadata;
  periodicity?: Periodicity;
};

const PanelTypeInfo: React.FC = () => (
  <>
    <section>
      <p>We report brand and product performance using the best available data source for your chosen time frame.</p>
    </section>
    <section>
      <p>Data from a Full Monthly or Weekly panel represents an overall market.</p>
    </section>
    <section>
      <p>
        Data from Weekly Channels measures overall performance from a sample of the most important channels. These might
        exclude some channels measured in the Full Monthly or Weekly panels.
      </p>
    </section>
    <section>
      <p>Data from the Weekly Leader panel comes from a smaller sample of leading retailers across various channels.</p>
    </section>
  </>
);

const ModalButton: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  return (
    <a
      data-test-id="panel-type-link"
      className="text-brand hover:text-brand-dark cursor-pointer pl-1"
      onClick={onClick}
    >
      Learn more
    </a>
  );
};

const PanelType: React.FC<PanelTypeProps> = ({ scopeMetadata, periodicity }) => {
  const showInfoModal = useInfoModal();

  const [data, setData] = useState({
    isVisible: false,
    message: '',
  });

  const onClick = () => {
    showInfoModal('Market data panels', <PanelTypeInfo />);
  };

  useEffect(() => {
    if (scopeMetadata) {
      setData({
        isVisible: true,
        message: ` Data based on Full ${capitalizeFirstLetter(scopeMetadata.periodType)} ${
          scopeMetadata.metadataValue
        }. `,
      });
    } else if (periodicity) {
      setData({
        isVisible: true,
        message: ` Data based on Full ${capitalizeFirstLetter(periodicity)} panel. `,
      });
    }
  }, [scopeMetadata, periodicity]);

  return data.isVisible ? (
    <div data-test-id="panel-type-warning" className="text-lighter inline flex-1 font-sm font-normal">
      <span data-test-id="panel-message">{data.message}</span>
      <ModalButton onClick={onClick} />
    </div>
  ) : null;
};

export default PanelType;
